
import Api from "../../common/APi/api";

export const TermsAndConditionsPageResponse = async(url:string)=>{
const response = await Api.get(url);

return response.data;
}
